<template>
  <div class="template-wrapper">
    <table class="table table-striped table-sm">
      <thead>
        <tr style="width: 100%">
          <th scope="col">Usługa</th>
          <th scope="col">Dla siebie/kogoś</th>
          <th scope="col">Termin Zam.</th>
          <th scope="col">Opiekun</th>
          <th scope="col">Telefon opiekuna</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {{
              currentProcess.last_order
                ? currentProcess.last_order.service_name
                : "-"
            }}
          </td>
          <td>
            {{
              currentProcess.last_order
                ? currentProcess.last_order.for_who
                : "-"
            }}
          </td>
          <td>
            {{
              currentProcess.last_order && currentProcess.last_order.period
                ? currentProcess.last_order.period[0]
                : "-"
            }}
            <span
              @click="showModal"
              style="cursor:pointer; font-weight:600; text-decoration:underline;"
              v-if="
                currentProcess.last_order &&
                  currentProcess.last_order.period &&
                  currentProcess.last_order.period.length > 1
              "
              >więcej</span
            >
          </td>
          <td>
            {{
              currentProcess.last_order
                ? currentProcess.last_order.employee_first_name +
                  " " +
                  currentProcess.last_order.employee_last_name
                : "-"
            }}
          </td>
          <td>
            {{
              currentProcess.last_order
                ? currentProcess.last_order.employee_phone
                : "-"
            }}
          </td>
          <td>
            {{
              currentProcess.last_order
                ? currentProcess.last_order.order_status
                : "-"
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["currentProcess"],
  emits: ["show-dates"],
  methods: {
    showModal() {
      this.$emit("show-dates");
    },
  },
};
</script>
<style scoped>
.table thead tr th {
  font-size: 16px;
  font-weight: 600;
  border: 1px solid rgba(9, 7, 65, 0.25);
}
.table tbody tr td {
  background: #fff;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  border: 1px solid rgba(9, 7, 65, 0.25);
}
#listAllDatesModal {
  z-index: 99999999999;
}
</style>
